import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { AppBar, Container, ImageList, ImageListItem, Toolbar } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        appbar: {
            backgroundColor: "#fff",
        },
        toolbar: (_a = {
                backgroundColor: "#fff",
                boxShadow: "0 0.5px 0 0 #ddd"
            },
            _a[theme.breakpoints.up("sm")] = {
                paddingLeft: 24,
                paddingRight: 24,
            },
            _a),
        avatar: {
            width: 35,
            height: 35,
        },
        companyName: {
            marginLeft: 5,
            width: "10%",
            height: 20
        },
        articleList: {
            paddingTop: "2px"
        }
    });
});
export var LinkinBioSkeleton = function () {
    var styles = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { position: "static", elevation: 0, className: styles.appbar },
            React.createElement(Toolbar, { className: styles.toolbar },
                React.createElement(Skeleton, { animation: "wave", variant: "circle", className: styles.avatar }),
                React.createElement(Skeleton, { animation: "wave", className: styles.companyName }))),
        React.createElement(Container, { maxWidth: "md" },
            React.createElement(ImageList, { cols: 3, gap: 2, className: styles.articleList }, Array.from(new Array(9)).map(function (item, index) { return (React.createElement(ImageListItem, { style: { width: "33.3%", height: "auto", aspectRatio: "1" }, key: index },
                React.createElement(Skeleton, { key: "image-list-skeleton-".concat(item), variant: "rect", animation: "wave", height: "100%" }))); })))));
};
